module.exports = __webpack_public_path__ + "img/crypto6.4c4845d0.png";